module.exports = __webpack_public_path__ + "de43e343cc1ef910bbf841886338ac7c.MP3";